import { Routes } from '@angular/router';

export const publicRoutes: Routes = [
    { path: 'tutorials', loadComponent: () => import('./dashboard/tutorials/tutorials.page').then(mod => mod.TutorialsComponent) },
    { path: '**', pathMatch: 'full', loadComponent: () => import('./not-found/not-found.page').then(mod => mod.AuthNotFoundPage) },
];